import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getTodosClientes, getClientePorId } from '../../actions/index.js';
import Select from 'react-select';
import './ConsultarCliente.css';

const ConsultarCliente = ({ onClose }) => {
  const dispatch = useDispatch();
  const clientesReporte = useSelector(state => state.clientesReporte);
  
  const [clienteId, setClienteId] = useState('');
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [cargandoCliente, setCargandoCliente] = useState(false);

  // Extraer array de clientes
  const clientesArray = Array.isArray(clientesReporte) ? clientesReporte : [];

  useEffect(() => {
    dispatch(getTodosClientes());
  }, [dispatch]);

  // Crear opciones para el Select de clientes
  const opcionesClientes = clientesArray.map(cliente => ({
    value: cliente.id,
    label: cliente.nombre
  }));

  const handleClienteChange = async (opcion) => {
    const clienteId = opcion ? opcion.value : '';
    console.log('Cliente seleccionado ID:', clienteId);
    setClienteId(clienteId);
    setClienteSeleccionado(null); // Limpiar cliente anterior
    
    if (clienteId) {
      setCargandoCliente(true);
      try {
        // Obtener datos completos del cliente (incluye áreas y servicios asignados)
        const clienteCompleto = await dispatch(getClientePorId(clienteId));
        console.log('Cliente completo recibido:', clienteCompleto);
        
        if (clienteCompleto) {
          // El cliente ya viene con sus servicios asignados, no necesitamos hacer otra llamada
          setClienteSeleccionado(clienteCompleto);
          console.log('Cliente establecido:', clienteCompleto);
        } else {
          console.error('No se recibió cliente completo');
        }
      } catch (error) {
        console.error('Error al cargar cliente:', error);
      } finally {
        setCargandoCliente(false);
      }
    } else {
      // Si se limpia el select, limpiar el estado
      setCargandoCliente(false);
      setClienteSeleccionado(null);
    }
  };
  

  // Debug: mostrar el estado actual
  useEffect(() => {
    console.log('Estado clienteSeleccionado:', clienteSeleccionado);
    console.log('Estado clienteId:', clienteId);
    console.log('Estado cargandoCliente:', cargandoCliente);
  }, [clienteSeleccionado, clienteId, cargandoCliente]);

  const renderTablaCliente = () => {
    console.log('Renderizando tabla, clienteSeleccionado:', clienteSeleccionado);
    
    if (!clienteSeleccionado) {
      console.log('No hay cliente seleccionado');
      return null;
    }

    console.log('Cliente areas:', clienteSeleccionado.areas);
    console.log('Cliente servicios (solo los asignados):', clienteSeleccionado.servicios);

    // Función para agrupar servicios asignados por área
    const agruparServiciosPorArea = () => {
      const areasConServicios = [];
      
      if (clienteSeleccionado.areas && clienteSeleccionado.servicios) {
        clienteSeleccionado.areas.forEach(area => {
          // Buscar solo los servicios ASIGNADOS que pertenezcan a esta área
          const serviciosDelArea = clienteSeleccionado.servicios.filter(servicio => {
            console.log(`Comparando servicio ${servicio.nombre}:`, {
              servicioAreaId: servicio.areaId,
              servicioArea_id: servicio.area_id,
              servicioArea: servicio.area,
              areaId: area.id,
              areaNombre: area.nombre
            });
            
            // Múltiples formas de matching igual que EditarClienteSimple
            return (
              servicio.areaId === area.id ||
              servicio.area_id === area.id ||
              servicio.area === area.nombre ||
              (servicio.Area && servicio.Area.id === area.id) ||
              (servicio.area && servicio.area.id === area.id)
            );
          });
          
          console.log(`Área ${area.nombre}: ${serviciosDelArea.length} servicios encontrados`, serviciosDelArea);
          
          areasConServicios.push({
            ...area,
            servicios: serviciosDelArea
          });
        });
      }
      
      console.log('Areas con servicios agrupados:', areasConServicios);
      return areasConServicios;
    };

    const areasConServicios = agruparServiciosPorArea();

    return (
      <div className="tabla-cliente-container">
        <div className="cliente-info">
          <h3>Información del Cliente</h3>
          <div className="cliente-detalle">
            <p><strong>Nombre:</strong> {clienteSeleccionado.nombre}</p>
            <p><strong>ID:</strong> {clienteSeleccionado.id}</p>
          </div>
        </div>

        {areasConServicios && areasConServicios.length > 0 && (
          <div className="areas-servicios-container">
            <h4>Áreas y Servicios</h4>
            <table className="tabla-areas-servicios">
              <thead>
                <tr>
                  <th>Área</th>
                  <th>Servicios</th>
                </tr>
              </thead>
              <tbody>
                {areasConServicios.map((area, index) => (
                  <tr key={area.id || index}>
                    <td className="area-cell">{area.nombre}</td>
                    <td className="servicios-cell">
                      {area.servicios && area.servicios.length > 0 ? (
                        <ul className="servicios-lista">
                          {area.servicios.map((servicio, servIndex) => (
                            <li key={servicio.id || servIndex} className="servicio-item">
                              {servicio.nombre}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <span className="sin-servicios">Sin servicios</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {(!areasConServicios || areasConServicios.length === 0) && (
          <div className="sin-areas">
            <p>Este cliente no tiene áreas asignadas.</p>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="consultar-cliente-overlay">
      <div className="consultar-cliente-modal">
        <div className="modal-header">
          <h2>Consultar Cliente</h2>
          <button className="btn-close" onClick={onClose}>
            <img src={require('../../images/cruz-verde.svg').default} alt="Cerrar" />
          </button>
        </div>

        <div className="modal-body">
          <div className="selector-cliente">
            <label>Seleccionar Cliente:</label>
            <Select
              className="consultar-cliente-select"
              value={opcionesClientes.find(opcion => opcion.value === clienteId)}
              onChange={handleClienteChange}
              options={opcionesClientes}
              placeholder="Busque y seleccione un cliente..."
              isSearchable
              isClearable
              menuPortalTarget={document.body}
              menuPosition="fixed"
              components={{
                IndicatorSeparator: () => null,
              }}
              styles={{
                control: (provided, state) => ({ ...provided, backgroundColor: '#0A100D', border: state.isFocused ? '0.5px solid rgba(40,199,111,0.6)' : '0.5px solid rgba(255,255,255,0.10)', borderRadius: '10px', color: '#E8EFEA', minHeight: '42px', boxShadow: state.isFocused ? '0 0 0 2px rgba(40,199,111,0.20)' : 'none', '&:hover': { borderColor: 'rgba(40,199,111,0.45)' } }),
                menu: (provided) => ({ ...provided, backgroundColor: '#0C120F', border: '0.5px solid rgba(40,199,111,0.25)', borderRadius: '11px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.6)', zIndex: 9999 }),
                menuList: (provided) => ({ ...provided, padding: '6px' }),
                menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? 'rgba(40,199,111,0.16)' : state.isFocused ? 'rgba(40,199,111,0.12)' : 'transparent', color: state.isSelected || state.isFocused ? '#EAF6EF' : '#CBD6CF', borderRadius: '8px', padding: '9px 11px', cursor: 'pointer' }),
                singleValue: (provided) => ({ ...provided, color: '#E8EFEA' }),
                input: (provided) => ({ ...provided, color: '#E8EFEA' }),
                placeholder: (provided) => ({ ...provided, color: '#9FB0A6' }),
                dropdownIndicator: (provided, state) => ({ ...provided, color: state.isFocused ? '#3FE07F' : '#5C6862', '&:hover': { color: '#3FE07F' } }),
                clearIndicator: (provided) => ({ ...provided, color: '#9FB0A6', '&:hover': { color: '#E86D6D' } }),
              }}
            />
          </div>

          {cargandoCliente && (
            <div className="cargando">
              <p>Cargando información del cliente...</p>
            </div>
          )}

          {!cargandoCliente && clienteId && renderTablaCliente()}
          
          {!cargandoCliente && clienteId && !clienteSeleccionado && (
            <div className="sin-datos">
              <p>No se pudieron cargar los datos del cliente seleccionado.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConsultarCliente;
